module.exports = __webpack_public_path__ + "img/selected7-min.c6cf4674.png";